import { useMemo } from 'react';

function isDateFuture(date) {
    const today = new Date();
    if (new Date(today.setHours(0, 0, 0, 0)) >= date) {
        return false;
    }
    return true;
}
function isValidDate(date) {
    if (date.match(/(?:(?:0[1-9]|1[0-2])[- /.]?(?:0[1-9]|[12][0-9])|(?:(?:0[13-9]|1[0-2])[- /.]?30)|(?:(?:0[13578]|1[02])[- /.]?31))[- /.]?(?:19|20)[0-9]{2}/)) {
        return true;
    }
    return false;
}
function getValidationRules({ type, matchAgainst, }) {
    switch (type) {
        case 'required':
            return {
                required: 'Required field',
            };
        case 'requiredGroup':
            return {
                validate: value => {
                    const message = 'Please select at least 1 option';
                    if (!value) {
                        return message;
                    }
                    return value.length ? true : message;
                },
            };
        case 'shortText':
            return {
                maxLength: {
                    value: 100,
                    message: 'Maximum 100 characters',
                },
            };
        case 'longText':
            return {
                maxLength: {
                    value: 500,
                    message: 'Maximum 500 characters',
                },
            };
        case 'number':
            return {
                pattern: {
                    value: /(\d+(\.\d+)?)/,
                    message: 'Only numbers allowed',
                },
            };
        case 'email':
            return {
                pattern: {
                    value: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
                    message: 'Invalid email',
                },
            };
        case 'password':
            return {
                minLength: {
                    value: 8,
                    message: 'Minimum 8 characters',
                },
                maxLength: {
                    value: 100,
                    message: 'Maximum 100 characters',
                },
                pattern: {
                    value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).*$/,
                    message: 'Must have at least 1 lowercase letter, 1 number and 1 capitalized letter',
                },
            };
        case 'valueConfirm':
            return {
                validate: value => value === matchAgainst || "Values don't match",
            };
        case 'birthDate':
            return {
                validate: value => {
                    if (!value) {
                        return true;
                    }
                    if (!isValidDate(value)) {
                        return 'Enter a date in the MM/DD/YYYY format';
                    }
                    const [month, day, year] = value.split('/');
                    return isDateFuture(new Date(year, month, day))
                        ? 'Birthdate cannot be in the future'
                        : true;
                },
            };
        case 'date':
            return {
                validate: value => {
                    if (!value) {
                        return true;
                    }
                    return isValidDate(value)
                        ? true
                        : 'Enter a date in the MM/DD/YYYY format';
                },
            };
        case 'zipcode':
            return {
                pattern: {
                    value: /^\d{5}(?:[-\s]\d{4})?$/,
                    message: 'Enter a valid US zipcode',
                },
            };
        default:
            return {};
    }
}
const useValidations = ({ validations, matchAgainst, max, min, }) => {
    const validationObject = useMemo(() => validations.reduce((arr, curr) => {
        return { ...arr, ...getValidationRules({ type: curr, matchAgainst }) };
    }, {}), [matchAgainst, validations]);
    const minMax = useMemo(() => ({
        ...(max
            ? {
                max: {
                    value: parseInt(max),
                    message: `Maximum value is ${max}`,
                },
                setValueAs: v => parseInt(v),
            }
            : {}),
        ...(min
            ? {
                min: {
                    value: parseInt(min),
                    message: `Minimum value is ${min}`,
                },
                setValueAs: v => parseInt(v),
            }
            : {}),
    }), [max, min]);
    return {
        ...validationObject,
        ...minMax,
    };
};

export { useValidations };
//# sourceMappingURL=useValidations.js.map
